
import { Alert,Snackbar } from '@mui/material';
import { createContext, useState } from 'react';
import './Styles/App.css';
import RouteManager from './Router/RouteManager';
import { store } from './store';
import { Provider, useSelector } from 'react-redux';
import CacheBuster from './Components/CacheBuster';
export const ContextNotification = createContext();
export const severitys = { success: 'success', info: "info", warning: 'warning', error: 'error' }

function App() {
  const [open, setOpen] = useState({ IsEnable: false, Message: "", severity: severitys.success });
  const handleClose = (reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen({ IsEnable: false, Message: "", severity: severitys.success });
  };

  return (
  <div>
    <CacheBuster/>
    <div className="App">
      <Snackbar open={open.IsEnable} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={open.severity}
          variant="filled"
          sx={{ width: '100%', fontFamily:'IRNazaninBold' }}
        >
          {open.Message}
        </Alert>
      </Snackbar>
      <ContextNotification.Provider value={{ open, setOpen }}>
      <Provider store={store}>
        <RouteManager />
        </Provider>
        
      </ContextNotification.Provider>
    </div>
    </div>
    
  );
}

export default App;
